import purify from 'dompurify';
import type { IOptions } from 'sanitize-html';

import { SANITIZE_ALLOWED_LINK_ATTRIBUTES, SANITIZE_ALLOWED_TAGS } from './sanitizeOptions';

// Stands in for sanitize-html in client bundles (turbopack.resolveAlias in next.config.js): sanitize-html carries
// postcss and htmlparser2 (about 60 KB gzipped), DOMPurify relies on the browser's own parser.
// The server still renders with sanitize-html; this one only runs in the browser, on client-side navigation.
const sanitizeHtml = (html: string, _options?: IOptions): string =>
  purify.sanitize(html, {
    ALLOWED_TAGS: SANITIZE_ALLOWED_TAGS,
    ALLOWED_ATTR: SANITIZE_ALLOWED_LINK_ATTRIBUTES,
    // kept by DOMPurify by default, stripped by sanitize-html: the client must render what the server rendered
    ALLOW_DATA_ATTR: false,
    ALLOW_ARIA_ATTR: false,
  });

export default sanitizeHtml;
